'use client'
import ChevronIcon from '@/icons/ChevronIcon'
import {useEffect, useState} from 'react'

const categories = ['All news', 'Projects', 'Press', 'Culture']

type Props = {
  filterNews: (category: string) => void
}
const Filters = ({filterNews}: Props) => {
  const [selectedCategory, setSelectedCategory] = useState('All news')
  const [expanded, setExpanded] = useState(false)
  const [translateSize, setTranslateSize] = useState(0)

  useEffect(() => {
    const moveFilters = () => {
      const activeCategory = document.querySelector(`#${selectedCategory.replace(' ', '-')}`)
      if (!activeCategory) return

      const rect = activeCategory.getBoundingClientRect()
      const translateX = window.innerWidth / 2 - (rect.left + rect.width / 2)
      setTranslateSize(prev => prev + translateX)
    }
    moveFilters()

    window.removeEventListener('resize', moveFilters)
    window.addEventListener('resize', moveFilters)

    return () => window.removeEventListener('resize', moveFilters)
  }, [selectedCategory])

  const onCategorySelect = (category: string) => {
    setSelectedCategory(category)
    filterNews(category)
    setExpanded(false)
  }

  return (
    <div className="opacity-1 translate-0 col-span-4 flex w-full flex-col items-center justify-center gap-y-8 overflow-hidden pb-8 pt-16 transition-[opacity] duration-500 ease-in starting:translate-y-3 starting:opacity-0 md:col-span-8 lg:col-span-12 lg:gap-y-12 lg:pb-16 lg:pt-32">
      <div
        className="lg:text-heading-lg mx-auto flex cursor-pointer items-center gap-x-1 text-headline-md"
        onClick={() => setExpanded(prev => !prev)}
      >
        <span>Category</span>
        <ChevronIcon className={`transition-transform duration-200 ease-out ${expanded ? '-scale-y-100' : ''}`} />
      </div>
      <div className="flex w-full flex-col">
        <section
          className={`flex flex-col items-center transition-[max-height,opacity] duration-200 ease-out text-headline-lg ${expanded ? 'max-h-48 opacity-100' : '-z-10 max-h-0 opacity-0'}`}
        >
          {categories.map(label => (
            <span
              key={label}
              onClick={() => onCategorySelect(label)}
              className={`cursor-pointer ${selectedCategory === label ? 'text-black' : 'text-black-md hover:text-black'}`}
            >
              {label}
            </span>
          ))}
        </section>
        <section
          className={`w-screen select-none overflow-hidden transition-[max-height,opacity] duration-200 ease-out text-display-sm lg:gap-x-10 lg:text-display-xl ${expanded ? 'max-h-0 opacity-0' : 'min-h-[1em] opacity-100 lg:max-h-28'}`}
        >
          <div
            className="transition-transform duration-200 ease-out lg:absolute lg:left-0"
            style={{transform: `translateX(${translateSize}px)`}}
          >
            <ul className="flex gap-x-8">
              {categories.map(label => (
                <li
                  key={label}
                  id={label.replace(' ', '-')}
                  className={`cursor-pointer whitespace-nowrap uppercase ${selectedCategory === label ? '' : 'text-white [-webkit-text-stroke:1px_black] hover:text-black hover:[-webkit-text-stroke:0px]'}`}
                  onClick={() => onCategorySelect(label)}
                >
                  {label}
                </li>
              ))}
            </ul>
          </div>
        </section>
      </div>
    </div>
  )
}

export default Filters
